import React from 'react';

import Routes from './routes';
import GlobalStyle from './styles/globals';

function App() {
  return (
    <>
      <Routes />
      <GlobalStyle /> 
    </>
  );
}

export default App;
